import {
  AuthenticationService,
  IUserData,
  SigninResponse,
} from "./authentication/authentication";
import { MicroServicesConfiguration } from "./configuration/configuration";
import { endpoints } from "./endpoints";
import { ServicesCollection } from "./index";
import { l10nService } from "./l10n";
import { ModalService } from "./modal";
import { BUType } from "./tracking/tracking";

export const getUserDataMockup: (
  bu: BUType,
  lang: string
) => Partial<IUserData> = (bu: BUType = "Capifrance", lang = "fr") => ({
  "AspNet.Identity.SecurityStamp": "VKQ6E6EWCU5IC7FQOLRA53STAFKEX4HE",
  Coordonnees: "43.6708898 7.05260309999994",
  Droits: "{}",
  Instance: bu,
  InterlocuteurId: "12333",
  IsAdmin: "False",
  IsStaff: "False",
  NiveauElite: "",
  Specialite: "",
  UniqueId: "78af710b-c5a5-4d3b-9b64-4651301201cf",
  access_token:
    "eyJhbGciOiJSUzI1NiIsImtpZCI6IjkwOEYzNTUzMDlENDY2MzAwQjczMzI2NjhCNUMzN0VCQzM2ODZBRDMiLCJ0eXAiOiJhdCtqd3QiLCJ4NXQiOiJrSTgxVXduVVpqQUxjekptaTF3MzY4Tm9hdE0ifQ.eyJuYmYiOjE2MjM4NTEyMjIsImV4cCI6MTYyMzg4MDAyMiwiaXNzIjoiaHR0cHM6Ly9zc28udHJlbXBsaW54LWRldi5mciIsImF1ZCI6WyJTZXJ2aWNlLUEiLCJTZXJ2aWNlLUIiLCJHYXRld2F5IiwiQ29udGFjdCIsIkNvbnRhY3RIYW5kbGVyIiwiVHJlbXBsaW5YU2VydmVyIiwiR2VvbG9jIiwiUmVwb3J0aW5nIiwiUmFwcHJvY2hlbWVudCIsIkNvbnRhY3RDb21tYW5kcyIsIlJjdSIsIk9mZmljZTM2NSIsIkNvbnNlaWxsZXIiLCJQaWdlIiwiTWFuYWdlciIsIk5vdGlmaWNhdGlvbnMiLCJNYXJrZXRpbmdDYW1wYWlnbnMiLCJEUiJdLCJjbGllbnRfaWQiOiJUcmVtcGxpblgtRnJvbnQ6ODRDMUQ5MzY3RTkzNkZCM0Q0Nzk1NEJGODBFNjlCMzZGODFCRjgxOEJDRkVEREI2MTkwQkYwMTkxNEE3NjI5MCIsInN1YiI6ImM4N2FhMmY4LTRmYTktNDhkNi1hNjEwLTBjYTRjYjkwZGZlNyIsImF1dGhfdGltZSI6MTYyMzgzMTEwOCwiaWRwIjoibG9jYWwiLCJBc3BOZXQuSWRlbnRpdHkuU2VjdXJpdHlTdGFtcCI6IlZLUTZFNkVXQ1U1SUM3RlFPTFJBNTNTVEFGS0VYNEhFIiwiSXNBZG1pbiI6IkZhbHNlIiwiVW5pcXVlSWQiOiI3OGFmNzEwYi1jNWE1LTRkM2ItOWI2NC00NjUxMzAxMjAxY2YiLCJJbnRlcmxvY3V0ZXVySWQiOiIxMjMzMyIsIklzU3RhZmYiOiJGYWxzZSIsIkRyb2l0cyI6Int9IiwiSW5zdGFuY2UiOiJDYXBpZnJhbmNlIiwiTml2ZWF1RWxpdGUiOiIiLCJTcGVjaWFsaXRlIjoiIiwiQ29vcmRvbm5lZXMiOiI0My42NzA4ODk4IDcuMDUyNjAzMDk5OTk5OTQiLCJwaWN0dXJlIjoiaHR0cHM6Ly9hc3NldHMtdHJlbXBsaW4tcHJlcHJvZC5henVyZWVkZ2UubmV0L2FwaS9maWxlbWFuYWdlci9DYXBpL3RodW1iLzE1OHgyMDIvMzk1Y2UwNDEtOWNiZC00YWQ4LTk2MGEtZTE2ODYzZDE1M2JkIiwiZ2l2ZW5fbmFtZSI6IkVtbWEiLCJmYW1pbHlfbmFtZSI6IkJMQU5DIiwiZW1haWwiOiJlbW1hLmJsYW5jQHByZXByb2QuY2FwaWZyYW5jZS5mciIsInBob25lX251bWJlciI6IiszMzc4MjcwMDUzNSIsInByZWZlcnJlZF91c2VybmFtZSI6ImVtbWEuYmxhbmNAY2FwaWZyYW5jZS5mciIsIm5hbWUiOiJlbW1hLmJsYW5jQGNhcGlmcmFuY2UuZnIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicm9sZSI6InVzZXIiLCJzY29wZSI6WyJvcGVuaWQiLCJwcm9maWxlIiwiU2VydmljZS1BIiwiU2VydmljZS1CIiwiR2F0ZXdheSIsIkNvbnRhY3QiLCJDb250YWN0SGFuZGxlciIsIlRyZW1wbGluWFNlcnZlciIsIkdlb2xvYyIsIlJlcG9ydGluZyIsIlJhcHByb2NoZW1lbnQiLCJDb250YWN0Q29tbWFuZHMiLCJSY3UiLCJPZmZpY2UzNjUiLCJDb25zZWlsbGVyIiwiUGlnZSIsIk1hbmFnZXIiLCJOb3RpZmljYXRpb25zIiwiTWFya2V0aW5nQ2FtcGFpZ25zIiwiRFIiXSwiYW1yIjpbInB3ZCJdfQ.KEZ1vMbxdnykrleug6xM79HFLRRiXJ-_nz3HNlldYR6VG5pv38HSaKXwkQ6lbrGSOhOM5sK0fNJLKci_kfm6UvtXlIk4S3j8x1SUcYslJrk1plOEd0DfCT8t9s6H1_OCveouCC0A3-DOj1xMr5SsPMUrdCsb9dBc05-4usDIHA0kfQb0muP1WBnlyrYSh4ZmLqsZpkZR03sXzieimVMoe8ZzAIy-a8dbwHE4hTkOHt7oaslLs7lICWiiBvAvCr4CaUVqWGnBIfZV3ysz4VSrwRpoMkAVN0qAwe8Ex95tC3Z5pUezQBIVHH_P81luGTkfK07TfSIC43SeCmrqQpp-xN_gdoccqraH-oaB28dNTmjoiLVPCkYpJNrHEfjcw9l6NN1b5TfY9R-kynThXu7i775UnxMb8LCh3yOw0hHlVFfXHnyeC_u7v52vNkZrgECbSoqqtROvOSdfGO8zWB09IH385rb95j9MQCk8u1GP-oIpo8n9m_WxYsKEWYDrab8AzlXhO7j79mSZiNqUhRsoAlyCT8jJzkaWZwAOLBK8HDKiS2jyJ09_HdO11ChiTM54xigZ5BirgS1ms6yb3drGlbWjOJ1wiQYt0uG-XDpB3y9jXyYaxffxgNtkOK_EH9lywRf8GImt5ysqg-uJwotRWwFmOjfdh1bY8jRzgTrqxbQ",
  amr: ["pwd"],
  aud: [
    "Service-A",
    "Service-B",
    "Gateway",
    "Contact",
    "ContactHandler",
    "TremplinXServer",
    "Geoloc",
    "Reporting",
    "Rapprochement",
    "ContactCommands",
    "Rcu",
    "Office365",
    "Conseiller",
    "Pige",
    "Manager",
    "Notifications",
    "MarketingCampaigns",
    "DR",
  ],
  auth_time: 1623831108,
  client_id:
    "TremplinX-Front:84C1D9367E936FB3D47954BF80E69B36F81BF818BCFEDDB6190BF01914A76290",
  email: "emma.blanc@preprod.capifrance.fr",
  email_verified: true,
  exp: 1623880022,
  expires_at: 1623880022,
  family_name: "BLANC",
  given_name: "Emma",
  id_token:
    "eyJhbGciOiJSUzI1NiIsImtpZCI6IjkwOEYzNTUzMDlENDY2MzAwQjczMzI2NjhCNUMzN0VCQzM2ODZBRDMiLCJ0eXAiOiJKV1QiLCJ4NXQiOiJrSTgxVXduVVpqQUxjekptaTF3MzY4Tm9hdE0ifQ.eyJuYmYiOjE2MjM4NTEyMjIsImV4cCI6MTYyMzg1MTUyMiwiaXNzIjoiaHR0cHM6Ly9zc28udHJlbXBsaW54LWRldi5mciIsImF1ZCI6IlRyZW1wbGluWC1Gcm9udDo4NEMxRDkzNjdFOTM2RkIzRDQ3OTU0QkY4MEU2OUIzNkY4MUJGODE4QkNGRUREQjYxOTBCRjAxOTE0QTc2MjkwIiwibm9uY2UiOiIyYmY5NjNjYWNmNWQ0MGViYWRmZmIwOWJiMmU1OTBlMCIsImlhdCI6MTYyMzg1MTIyMiwiYXRfaGFzaCI6IkxrTDkyMjd4ZGxaU1pTdHB2Rm1LRUEiLCJzX2hhc2giOiJMcmk1cFI0NG1pUVZpRDQzT2d5TmNRIiwic2lkIjoiOGlYS3lmMkUwWFFVLXFPQlNNSDJzdyIsInN1YiI6ImM4N2FhMmY4LTRmYTktNDhkNi1hNjEwLTBjYTRjYjkwZGZlNyIsImF1dGhfdGltZSI6MTYyMzgzMTEwOCwiaWRwIjoibG9jYWwiLCJhbXIiOlsicHdkIl19.yFoV624yzGDMoJIrxDNxDo4edHsB1T1AVOVcbbl4cb0Y8_uEb6ln0Omc43a-HOOxtajN78ZQHtefrRymKO0eTK91A2otjatjhBNnMi7vkT-b2qhio73lo6bJL3xDTQW1KONLorRZxM-gd-69RS_p8TDjSWzE1MfHXRYcEx0MTNoe66kqQrSt3KymwOQLQcQSbHx7JV7b2RWShJZDLUna8SCXSNbBIwuAeo6-KZWna7DfWJ4ddnDcxTLTIVgb7bWEyQmISphw42XoI6psj-8RJJIYXQEwTHDOR5hNaJ-UAQFrRVcoSw_WSsRzf9YF6k7CeaABPPsv__8bRq-v1-WkOxkuJJsjRK7oKqg85FB8SGpjeTzfFw3T-u0Wq6UoBcCeCGSj4PWnXr6jUOmsFZEPR9xGrJBtaur-V4mWnGWVfrtlD4oXooMVeZ8K8Zb7yLfzTc2l70F3a2ovI4WrS3V8XTO-4fSFIET8SjAarhJTRO0htAxDTxL_QqhtzodU6OuGIBdGRAXClGdTUEhmJ1UHBvl7P7dk6YylTBWp5HWPc1vcH_5kjYwlRMDd8-jGspcNOFf9p0UdELiJWpVe5kuTXOt2Fk4AxX5mnVvAXf-IUzRzQmd8YnOChlTBHeega5umLEKLmXn-stguU6_bLxtp0jei_lHX_Ou4NLl7PJsiJLM",
  idp: "local",
  iss: "https://sso.tremplinx-dev.fr",
  language: lang,
  name: "emma.blanc@capifrance.fr",
  nbf: 1623851222,
  phone_number: "+33782700535",
  picture:
    "https://assets-tremplin-preprod.azureedge.net/api/filemanager/Capi/thumb/158x202/395ce041-9cbd-4ad8-960a-e16863d153bd",
  preferred_username: "emma.blanc@capifrance.fr",
  profile: {
    "AspNet.Identity.SecurityStamp": "VKQ6E6EWCU5IC7FQOLRA53STAFKEX4HE",
    Coordonnees: "43.6708898 7.05260309999994",
    Droits: "{}",
    Instance: "Capifrance",
    InterlocuteurId: "12333",
    IsAdmin: "False",
    IsStaff: "False",
    NiveauElite: "",
    Specialite: "",
    UniqueId: "78af710b-c5a5-4d3b-9b64-4651301201cf",
    amr: ["pwd"],
    auth_time: 1623831108,
    email: "emma.blanc@preprod.capifrance.fr",
    email_verified: true,
    family_name: "BLANC",
    given_name: "Emma",
    iat: "2021-06-16 08:11:48Z",
    idp: "local",
    name: "emma.blanc@capifrance.fr",
    phone_number: "+33782700535",
    picture:
      "https://assets-tremplin-preprod.azureedge.net/api/filemanager/Capi/thumb/158x202/395ce041-9cbd-4ad8-960a-e16863d153bd",
    preferred_username: "emma.blanc@capifrance.fr",
    role: "user",
    s_hash: "Lri5pR44miQViD43OgyNcQ",
    sid: "8iXKyf2E0XQU-qOBSMH2sw",
    sub: "c87aa2f8-4fa9-48d6-a610-0ca4cb90dfe7",
  },
  role: "user",
  scope: [
    "openid",
    "profile",
    "Service-A",
    "Service-B",
    "Gateway",
    "Contact",
    "ContactHandler",
    "TremplinXServer",
    "Geoloc",
    "Reporting",
    "Rapprochement",
    "ContactCommands",
    "Rcu",
    "Office365",
    "Conseiller",
    "Pige",
    "Manager",
    "Notifications",
    "MarketingCampaigns",
    "DR",
  ],
  session_state:
    "caFw6FAezFHTGZP_uGiwwuCO9OZq5T77-6PpGDo4t80.rIhQmia4VWh1LdvIuKAggQ",
  sub: "c87aa2f8-4fa9-48d6-a610-0ca4cb90dfe7",
  token_type: "Bearer",
});

export const createServicesCollectionMockup = (
  bu: BUType = "Capifrance",
  lang = "fr"
): ServicesCollection => {
  const authenticationService: AuthenticationService = {
    getUserData: () => getUserDataMockup(bu, lang),
    isAuthenticated: () => true,
    login: () => void 0,
    logout: () => void 0,
    processSigninResponse: () => new Promise<SigninResponse>(() => true),
    setCallback: () => ({}),
  };
  const modal = ModalService();
  const microServices: MicroServicesConfiguration = {
    crmLegacyProfileCapifrance: "https//some-microservice.tremplinx-dev.fr",
    crmLegacyProfileOptimhome: "https//some-microservice.tremplinx-dev.fr",
    lineup7: "https//some-microservice.tremplinx-dev.fr",
    tx: (service) => `https://${service}.tremplinx-dev.fr`,
  };

  return {
    appInfo: {
      environnementLabel: "TEST",
    },
    authenticationService,
    campaigns: {
      getCurrentCampaigns: () => Promise.resolve([]),
      subscribe: () => Promise.resolve(undefined),
      unsubscribe: () => Promise.resolve(undefined),
    },
    contactEvents: {
      addEvent: () => Promise.resolve(undefined),
      deleteEvent: () => Promise.resolve(undefined),
      getEvents: () => Promise.resolve([]),
      updateEvent: () => Promise.resolve(undefined),
    },
    endpoints: endpoints(microServices),
    l10n: l10nService(() => authenticationService.getUserData()?.language),
    modal,
    trackingService: {
      sendCustomEventToGoogle: () => null,
      sendPageViewEventToGoogle: () => null,
    },
  };
};
